export const HOME_PATH = '/';

export const DROP_PATH = '/drop';

export const GRAB_PATH = '/grab';

export const OVERVIEW_DOCS_PATH = '/docs/overview';

export const CLI_DOCS_PATH = '/docs/features/cli';

export const WEB_DOCS_PATH = '/docs/features/web';

export const VSCODE_DOCS_PATH = '/docs/features/vscode';

export const DESKTOP_DOCS_PATH = '/docs/features/desktop';

export const FAQS_DOCS_PATH = '/docs/faqs';

export const FEATURES_DOCS_PATH = '/docs/features';

export const CAPTCHA_API_PATH = '/api/captcha';

export const DROP_API_PATH = '/drop';

export const PRICING_PATH = '/pricing';
